import Vue from 'vue';

const VueUpload = {};
VueUpload.error = null;

VueUpload.install = function (Vue, options) {
    Vue.prototype.$uploader = VueUpload;
}

// error types init....
VueUpload.IS_MAX_FILES = false;
VueUpload.IS_INVALID_TYPE = false;

VueUpload.getError = function () {
    return VueUpload.error;
}

VueUpload.configure = function (options) {

    let inputName = options.inputName;
    let targetObject = options.target;
    let events = options.events;
    let triggerWith = options.triggerWith;
    let previewContainer = options.previewContainer;
    let maxFiles = (options.maxFiles) ? options.maxFiles : 1;
    let fileTypes = (options.fileTypes) ? options.fileTypes : false;

    let onChangeEvent = (events.onChange) ? events.onChange : null;
    let onPushedEvent = (events.onPushed) ? events.onPushed : null;
    let onErrorEvent = (events.onError) ? events.onError : null;

    // If target is not a DOM object, initialize DOM object from it. 
    if (typeof targetObject == 'string') {
        targetObject = document.getElementById(targetObject);
    }

    if (targetObject == null) {
        return
    }

    if (typeof targetObject == 'string') {
        targetObject = document.getElementById(targetObject);
    }

    triggerWith.addEventListener('click', function () {
        targetObject.click();
    });

    targetObject.onchange = function (event) {
        let files = targetObject.files;
        let isOkay = true;

        if (files.length > maxFiles) {
            if (onErrorEvent) {
                VueUpload.IS_MAX_FILES = true;
                return onErrorEvent(files, length, 'Maximum file exceeded.');
            }
        }

        for (let i = 0; i < files.length; i++) {
            let file = files[i];

            if (fileTypes && fileTypes.length > 0) {
                if (!fileTypes.includes(file.type)) {
                    if (onErrorEvent) {
                        VueUpload.IS_INVALID_TYPE = true;

                        let fileType = file.type;

                        if (fileType == '') {
                            fileType = file.name;
                        }

                        return onErrorEvent(files, length, fileType + ' is not supported.');
                    }
                    return false;
                }
            }

            let reader = new FileReader();

            file.blob = URL.createObjectURL(file);
            file.extension = file.name.split('.').pop();
            file.filename = file.name.replace(/\.[^.$]+$/, '');
            reader.readAsDataURL(file);
            reader.onload = function () {
                file.base64 = reader.result;
            };

            if (onChangeEvent) {
                onChangeEvent(file, files, reader);
            }
        }

    };

    return VueUpload;
}

export default VueUpload;